<template>

  <!-- 布局 -->
  <div class="layout" >
    <!-- 工具栏区容器 -->
    <div class="toolbar-container">
      <!-- 工具栏 -->
      <toolbar></toolbar>
    </div>
    <!-- 模板容器 -->
    <div class="template-container">
      <!-- 素材区-->
      <page />
      <i class="el-icon-arrow-right btn"></i>
    </div>
    <!-- 动画编辑区容器 -->
    <div class="scene-container">
      <!-- 动画编辑区 -->
      <scene />
    </div>
    <!-- 动作时间轴区容器 -->
    <div class="action-timeline-container">
      <!-- 动作时间轴区 -->
      <action-timeline />
    </div>
    <!-- 面板区容器 -->
    <div class="panel-container">
      <!-- 面板区 右侧 -->
      <panel-right></panel-right>
    </div>
    <!-- 动画时间轴区容器 -->
    <div class="editor-timeline-container">
      <!-- 动画时间轴区 -->
      <editor-timeline />
    </div>
    <!--dialog面板 -->
    <div>
      <el-dialog title="收藏提示" v-model="dialog_collect_visible" size="tiny" :visible.sync="dialog_collect_visible">
      <span>确认是否收藏该素材？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_collect_visible = false">取 消</el-button>
        <el-button type="primary" @click="handleCollect">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="取消收藏提示" v-model="dialog_cancel_collect_visible" size="tiny" :visible.sync="dialog_cancel_collect_visible">
      <span>确认是否取消收藏该素材？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_cancel_collect_visible = false">取 消</el-button>
        <el-button type="primary" @click="handleCancelCollect">确 定</el-button>
      </span>
    </el-dialog>
    </div>
  </div>
</template>
<script>

  // 工具栏组件
  import Toolbar from '@/components/Toolbar/Toolbar'
  // 动画编辑器组件
  import Scene from '@/components/Scene/Scene'
  // 动画时间轴组件
  import EditorTimeline from '@/components/EditorTimeline/EditorTimeline'
  // 动作时间轴组件
  import ActionTimeline from '@/components/ActionTimeline/ActionTimeline'
  // 面板组件
  import PanelRight from '@/components/PanelRight/PanelRight'
  // 素材市场组件
  import Page from '@/components/Page/Page'
  import {eventBus} from '@/common/scripts/eventBus.js'
  // 工具类
  import EUY from '@/common/scripts/euy.js'
  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'
  export default {
    data(){
      return {
        dialog_collect_visible: false,
        dialog_cancel_collect_visible: false,
        component_name :String
      }
    },
    methods:{
      // 确认收藏
      handleCollect (event) {
        this.dialog_collect_visible = false
        eventBus.$emit('handleCollect_'+this.component_name);
      },
      // 确认取消收藏
      handleCancelCollect () {
          this.dialog_cancel_collect_visible = false
          eventBus.$emit('handleCancelCollect_'+this.component_name.toLowerCase());
      }
    },
    components: {
      Toolbar,
      Scene,
      EditorTimeline,
      ActionTimeline,
      PanelRight,
      Page
    },
    created(){
      eventBus.$on('dialogOpen',(event)=>{
        for (let key in event) {
          if (event.hasOwnProperty(key)) {
              this[key] = event[key]
          }
        }
      })
    },
    mounted () {
      let platform = this.$route.query.platform
      let action_timeline = $('.action-timeline-container')
      let editor_timeline = $('.editor-timeline-container')
      let template = $('.template-container')
      let scene = $('.scene-container')
      let panel_right = $('#PANELRIGHT-SWF')
      let tabs = $('#PANELRIGHT-SWF > .tabs-panel > .item')
      let panels = $('#PANELRIGHT-SWF > .panel-group > .panel')
      let t = $('#PANELRIGHT-SWF > .title')

      tabs.each(function (index) {
        $(this).on('click', function() {
            panel_right.css({ width: 280 })
            scene.css({ right: 336 })
            editor_timeline.css({ right: 336 })
            action_timeline.css({ right: 336 })
            $(this).addClass('active')
                .siblings().removeClass('active')
            panels.eq(index).show()
                .siblings().hide()
            if (index == 0) {
                t.html('素材')
            }else if (index == 1) {
                t.html('动作')
            }else if (index == 2) {
                t.html('镜头')
            }else if (index == 3) {
                t.html('文字')
            }else if (index == 4) {
                t.html('声音')
            }else if(index == 5) {
                t.html('样式')
            }else if (index == 6) {
                t.html('属性')
            }else if (index == 7) {
                t.html('设置')
            }else if (index == 8) {
                t.html('部件')
            }
            if(index == 1) {
                let action_core_1_21 = {
                packageId: 0,
                senderId: ACTIONINFO,
                senderName: ACTIONINFO_NAME,
                receiverId: ACTION,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: 21,
                protoBytesType: 'proto.com.proto.s.MUint32',
                protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MUint32(), {
                  setValue: ACTION,
                })
             }

                // 发送消息
                Protocol.sender(platform, action_core_1_21)
                return
            }
            // 在切换的时候关闭二级模块
            let action_core_1_20 = {
                packageId: 0,
                senderId: ACTIONINFO,
                senderName: ACTIONINFO_NAME,
                receiverId: CORE,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: 20,
                protoBytesType: "proto.com.proto.s.MUint32",
                protoBytes: Protocol.serializeBinary(
                    new proto.com.proto.s.MUint32(),
                    {
                        setValue: ACTION
                    }
                )
            };
            // 发送消息
            Protocol.sender(platform, action_core_1_20);
        })
      })
      let tab_type = EUY.GetStorage('currentTab').tab_type;
      let tabs_info = EUY.GetStorage('tabs_info');
      if (tab_type == 1) {
        action_timeline.hide()
        editor_timeline.show()
        template.show()
        scene.css({ left: 0, bottom: 78 })
        editor_timeline.css({ left: 0 })
        tabs.each(function (index) {
          $(this).css({ position: 'relative', left: 0 })
          if (index > 6) {
            $(this).css({ position: 'absolute', left: 50 })
          }
        })
    }else if (tab_type == 2) {
        action_timeline.show()
        editor_timeline.hide()
        template.hide()
        scene.css({ left: 0, bottom: 96 })
        action_timeline.css({ left: 0 })
        tabs.each(function (index) {
          $(this).css({ position: 'relative', left: 0 })
          if (index > 0 && index < 7) {
            $(this).css({ position: 'absolute', left: 50 })
          }
        })
      }else if(tab_type == 3) {
          action_timeline.hide()
          editor_timeline.hide()
          template.hide()
          scene.css({ left: 0, bottom: 0 })
          tabs.each(function (index) {
              $(this).css({ position: 'relative', left: 0 })
              if (index != 0 && index != 1 && index != 6) {
                  $(this).css({ position: 'absolute', left: 50 })
              }
          })
      }if (tab_type == 4) {
        action_timeline.hide()
        editor_timeline.hide()
        template.hide()
        scene.css({ left: 0, bottom: 0 })
        tabs.each(function (index) {
          $(this).css({ position: 'relative', left: 0 })
          if (index < 8) {
            $(this).css({ position: 'absolute', left: 50 })
          }
        })
      }
      $('.template-container > .btn').on('click', function() {
        let margin_left = ''
        let parent =  $(this).parent()
        let editor_timeline =  $('.editor-timeline-container')
        let action_timeline =  $('.action_timeline-container')
        let scene =  $('.scene-container')
        if (parent.width() == 0) {
          parent.css({ width: 160 })
          $(this).css({ left: 160 })
          $(this).get(0).className = 'btn el-icon-arrow-left'
          editor_timeline.css({ left: 160 })
          action_timeline.css({ left: 160 })
          scene.css({ left: 160 })
          margin_left = '160'
        } else {
          parent.css({ width: 0 })
          $(this).css({ left: 0 })
          $(this).get(0).className = 'btn el-icon-arrow-right'
          editor_timeline.css({ left: 0 })
          action_timeline.css({ left: 0 })
          scene.css({ left: 0 })
          margin_left = '0'
        }

        // 点击展开／关闭page页的消息
        let action_core_1_33 = {
                packageId: 0,
                senderId: CORE,
                senderName: CORE_NAME,
                receiverId: CORE,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: 33,
                protoBytesType: "proto.com.proto.s.MString",
                protoBytes: Protocol.serializeBinary(
                    new proto.com.proto.s.MString(),
                    {
                        setValue: margin_left
                    }
                )
            };

            // 发送消息
        Protocol.sender(platform, action_core_1_33);
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .toolbar-container
    width: 100%
    height: 36px
  .template-container
    position: absolute
    top: 36px
    left: 0px
    width: 0
    z-index: 100
    background red
    bottom: 0px
    .btn
      height 30px
      width 12px
      position absolute
      left 0
      top 45%
      margin-top -15px
      cursor pointer
      background #c9c9c9
      color #fff
      line-height 30px
      &:hover
        background #e1e1e1
      &:active
        background #949494
  .scene-container
    position: absolute
    top: 36px
    right: 50px
    bottom: 96px
    left: 160px
  .editor-timeline-container,
  .action-timeline-container
    position: absolute
    right: 50px
    bottom: 0
    left: 160px
    height: 96px
  .editor-timeline-container
    height 78px
  .panel-container
    position: absolute
    top: 36px
    right: 0
    bottom: 0
    width: 0
</style>



// WEBPACK FOOTER //
// Ui.vue?cea290e6